import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Star } from 'lucide-react';

interface AssessmentSummaryProps {
  aiRating: number;
  skillRatings: {
    skill: string;
    rating: number;
  }[];
  summary?: string;
}

const AssessmentSummary: React.FC<AssessmentSummaryProps> = ({
  aiRating,
  skillRatings,
  summary
}) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }).map((_, index) => (
      <Star
        key={index}
        size={16}
        className={`${
          index < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Assessment Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {summary && (
            <div>
              <h4 className="text-sm font-medium mb-2">AI Summary</h4>
              <p className="text-sm text-muted-foreground">{summary}</p>
            </div>
          )}
          
          <div>
            <h4 className="text-sm font-medium mb-2">AI Rating</h4>
            <div className="flex items-center space-x-1">
              {renderStars(aiRating)}
            </div>
          </div>
          
          <div>
            <h4 className="text-sm font-medium mb-2">Skill Ratings</h4>
            <div className="space-y-2">
              {skillRatings.map((skillRating, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-sm">{skillRating.skill}</span>
                  <div className="flex items-center space-x-1">
                    {renderStars(skillRating.rating)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentSummary; 